var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7673_1387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.64062 0.732422V14.2676C1.64062 14.6722 1.96846 15 2.37305 15H12.627C13.0315 15 13.3594 14.6722 13.3594 14.2676V3.22266L10.1367 0H2.37305C1.96846 0 1.64062 0.327832 1.64062 0.732422Z",
    fill: "url(#paint0_linear_7673_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 3.22266H10.8691C10.4646 3.22266 10.1367 2.89482 10.1367 2.49023V0L13.3594 3.22266Z",
    fill: "url(#paint1_linear_7673_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2676 7.38281H0.732422C0.327916 7.38281 0 7.71073 0 8.11523V12.5098C0 12.9143 0.327916 13.2422 0.732422 13.2422H14.2676C14.6721 13.2422 15 12.9143 15 12.5098V8.11523C15 7.71073 14.6721 7.38281 14.2676 7.38281Z",
    fill: "url(#paint2_linear_7673_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67188 2.63672H3.39844C3.23664 2.63672 3.10547 2.76789 3.10547 2.92969C3.10547 3.09149 3.23664 3.22266 3.39844 3.22266H8.67188C8.83368 3.22266 8.96484 3.09149 8.96484 2.92969C8.96484 2.76789 8.83368 2.63672 8.67188 2.63672Z",
    fill: "url(#paint3_linear_7673_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1367 4.10156H3.39844C3.23664 4.10156 3.10547 4.23273 3.10547 4.39453C3.10547 4.55633 3.23664 4.6875 3.39844 4.6875H10.1367C10.2985 4.6875 10.4297 4.55633 10.4297 4.39453C10.4297 4.23273 10.2985 4.10156 10.1367 4.10156Z",
    fill: "url(#paint4_linear_7673_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6016 5.56641H3.39844C3.23664 5.56641 3.10547 5.69757 3.10547 5.85938C3.10547 6.02118 3.23664 6.15234 3.39844 6.15234H11.6016C11.7634 6.15234 11.8945 6.02118 11.8945 5.85938C11.8945 5.69757 11.7634 5.56641 11.6016 5.56641Z",
    fill: "url(#paint5_linear_7673_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41936 8.71504L6.16321 11.0336L6.90471 8.71504H7.96204V12.0476H7.15637V11.2694L7.2343 9.67627L6.42864 12.0476H5.89778L5.08977 9.67393L5.1677 11.2691V12.0473H4.36438V8.71475H5.41965L5.41936 8.71504ZM8.33997 10.791C8.33997 10.399 8.42463 10.0899 8.59397 9.86406C8.76331 9.63818 8.99973 9.52539 9.30354 9.52539C9.52473 9.52539 9.71106 9.6124 9.86194 9.78643V8.53223H10.6357V12.0479H9.94221L9.90325 11.7824C9.74446 11.9898 9.54319 12.0936 9.29915 12.0936C9.00471 12.0936 8.77122 11.9808 8.59866 11.7549C8.4261 11.529 8.33997 11.2079 8.33997 10.7913V10.791ZM9.11135 10.8391C9.11135 11.2785 9.23967 11.4982 9.49573 11.4982C9.66653 11.4982 9.7887 11.4265 9.86194 11.2832V10.3401C9.79163 10.1937 9.67122 10.1204 9.50041 10.1204C9.26252 10.1204 9.13332 10.3126 9.1137 10.6973L9.11135 10.8391Z",
    fill: "url(#paint6_linear_7673_1387)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7673_1387",
    x1: 0.336328,
    y1: 1.7332,
    x2: 13.2668,
    y2: 14.6637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C6100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7673_1387",
    x1: 9.43828,
    y1: 0.698438,
    x2: 12.6609,
    y2: 3.92109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABE815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D8500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7673_1387",
    x1: 2.49961,
    y1: 5.31211,
    x2: 12.5004,
    y2: 15.3129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CB000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A6900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7673_1387",
    x1: 4.50967,
    y1: 1.4042,
    x2: 7.56064,
    y2: 4.45518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABE815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D8500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7673_1387",
    x1: 4.87588,
    y1: 2.50283,
    x2: 8.65928,
    y2: 6.28623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABE815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D8500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7673_1387",
    x1: 5.24209,
    y1: 3.60146,
    x2: 9.75791,
    y2: 8.11729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABE815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D8500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7673_1387",
    x1: 5.14485,
    y1: 7.93457,
    x2: 9.9469,
    y2: 12.7363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FFDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1FF9C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7673_1387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdIcon);
export default __webpack_public_path__ + "static/media/md-icon.2e4c9c7187fd7783a82a5553e344b073.svg";
export { ForwardRef as ReactComponent };